import { dateAdapter } from "@/plugins/vuetify";
import { useAppStore } from "@/stores/appStore";
import { useSurveyStore } from "@/stores/surveyStore";
Number.prototype.round = function (n) {
  const d = Math.pow(10, n);
  return Math.round((this + Number.EPSILON) * d) / d;
};
String.prototype.round = function (n) {
  const d = Math.pow(10, n);
  return Math.round((1 * this + Number.EPSILON) * d) / d;
};
Number.prototype.toMoneyFormat = function (
  currency = "USD",
  withSymbol = true,
  maximumFractionDigits = 2
) {
  if (!currency) return this;
  let minimumDigits = numZeroesAfterPoint(this);
  if (isNaN(minimumDigits)) {
    minimumDigits = 0;
  }
  if (minimumDigits > 0) {
    minimumDigits += 2;
  }
  const final =
    maximumFractionDigits === 0
      ? 0
      : Math.max(maximumFractionDigits, minimumDigits);
  const money = this.toLocaleString("dfawddcc", {
    style: "currency",
    currency,
    maximumFractionDigits: final,
  });
  if (withSymbol) return money;

  const currencies = useAppStore().getList("currencies");
  const curr =
    currency === "USD"
      ? { symbol: "$", code: "USD" }
      : currencies.find((curr) => curr.code === currency);
  if (!curr) return money;
  return money.replace(curr.symbol, "").replace(curr.code, "");
};
String.prototype.toMoneyFormat = function (
  currency = "USD",
  withSymbol = true,
  maximumFractionDigits = 2
) {
  return (1 * this).toMoneyFormat(currency, withSymbol, maximumFractionDigits);
};
export const numZeroesAfterPoint = (x) => {
  if (x % 1 == 0) {
    return 0;
  } else {
    return Math.min(-1 - Math.floor(Math.log10(x % 1)), 5);
  }
};
export const useFloat = (amount) => {
  return !amount ? 0 : isNaN(amount) ? 0 : parseFloat(amount);
};
export const multiFloat = (...args) => {
  return args.reduce((result, num) => result * useFloat(num), 1);
};

export const transformObject = (entity, property) => {
  const object = entity[property];
  Object.keys(object).forEach((key) => {
    if (Array.isArray(object[key])) {
      object[key].forEach((item, idx) => {
        Object.keys(item).forEach((k) => {
          entity[`${property}[${key}][${idx}][${k}]`] = item[k];
        });
      });
    } else {
      entity[`${property}[${key}]`] = object[key];
    }
  });
  delete entity[property];
};

export const transformArray = (entity, property) => {
  entity[property].forEach((object, index) => {
    if (!object) return;
    if ("id" in object && object.id !== "holded") {
      entity[`${property}[${index}][id]`] = object.id;
    }
    Object.keys(object).forEach((key) => {
      if (
        typeof object[key] === "object" &&
        !Array.isArray(object[key]) &&
        object[key] !== null &&
        "id" in object[key] &&
        object[key].id !== "holded"
      ) {
        entity[`${property}[${index}][${key}]`] = object[key].id ?? "isNull";
      } else {
        entity[`${property}[${index}][${key}]`] = object[key] ?? "";
      }
    });
  });
  delete entity[property];
};

export const transformPreSubmit = (entity) => {
  // parse property and format array property
  Object.keys(entity).forEach((key) => {
    // push
    // should I clear all before push ?
    if (key.includes("[]")) {
    }
    // set for case like entity['contacts[0]']
    const matches = [...key.matchAll(/([a-zA-Z]+)\[([0-9]+)\]/g)];
    if (matches.length > 0) {
      if (!entity[matches[0][1]]) entity[matches[0][1]] = [];
      entity[matches[0][1]][matches[0][2]] = entity[key];
      delete entity[key];
    }
  });
};

// print to local date from api
export const printDateTime = (
  dateString,
  outputFormat = "DD/MM/YYYY HH:mm"
) => {
  if (!dateString) return null;
  const date = dateAdapter.parseISO(dateString);
  return date.format(outputFormat);
};
// print to local date from api
export const printDate = (dateString, outputFormat = "DD/MM/YYYY") => {
  if (!dateString) return null;
  const date = dateAdapter.parseISO(dateString);
  return date.format(outputFormat);
};
// parse date from local from datepicker for api call
export const toUTCDate = (dateString, format = "DD/MM/YYYY HH:mm:ss") => {
  if (!dateString) return dateString;
  const date =
    dateString === "now"
      ? dateAdapter.date()
      : dateAdapter.parse(dateString, format);
  return dayJSToUTC(date);
};

export const dayJSToUTC = (dayJSDate) => {
  try {
    return dayJSDate.toISOString().replace("T", " ").replace(".000Z", "");
  } catch (err) {
    return "";
  }
};

export const printNullable = (string, prefix = null) => {
  return (string ?? "...") + (string && prefix ? " " + prefix : "");
};

export const printPersonName = (person) => {
  return !(person.firstName && person.lastName)
    ? "..."
    : [person.firstName, person.lastName].join(" ");
};

export const operatorList = () => {
  return [
    {
      value: "eq",
      title: $gettext("equals"),
      symbol: "=",
      groups: ["*"],
    },
    {
      value: "isMemberOf",
      title: $gettext("contains"),
      symbol: "⊃",
      groups: ["isMemberOf"],
    },
    {
      value: "inArray",
      title: $gettext("in array"),
      symbol: "in",
      groups: ["select"],
      multiple: true,
    },
    {
      value: "neq",
      title: $gettext("not equals"),
      symbol: "≠",
      groups: ["text", "number"],
    },
    {
      value: "gt",
      title: $gettext("greater than"),
      symbol: ">",
      groups: ["number", "date"],
    },
    {
      value: "lt",
      title: $gettext("less than"),
      symbol: "<",
      groups: ["number", "date"],
    },
    {
      value: "gte",
      title: $gettext("greater than or equal to"),
      symbol: ">=",
      groups: ["number", "date"],
    },
    {
      value: "lte",
      title: $gettext("less than or equal to"),
      symbol: "<=",
      groups: ["number", "date"],
    },
    // text
    {
      value: "like",
      title: $gettext("contains"),
      symbol: "⊃",
      groups: ["text", "anywhere"],
    },
    {
      value: "startsWith",
      title: $gettext("starts with"),
      symbol: "^=",
      groups: ["text", "anywhere"],
    },
    {
      value: "isEmpty",
      title: $gettext("empty"),
      symbol: "∅",
      groups: ["text"],
      valueComponentDisabled: true,
    },
    // date
    {
      value: "between",
      title: $gettext("Between"),
      symbol: "()",
      dateConfig: {
        mode: "range",
        dateFormat: "DD/MM/YYYY",
        altInput: true,
        altFormat: "DD/MM/YYYY",
      },
      groups: ["number", "date"],
    },
    {
      value: "relativeRange",
      title: $gettext("Relative Range"),
      symbol: "[]",
      groups: ["date"],
      ranges: [
        { value: "Today", title: $gettext("Today") },
        { value: "ThisWeek", title: $gettext("This Week") },
        { value: "LastWeek", title: $gettext("Last Week") },
        { value: "ThisMonth", title: $gettext("This Month") },
        { value: "LastMonth", title: $gettext("Last Month") },
        { value: "ThreeMonths", title: $gettext("3 Months") },
        { value: "SixMonths", title: $gettext("6 Months") },
        { value: "ThisYear", title: $gettext("This Year") },
        { value: "LastYear", title: $gettext("Last Year") },
        { value: "ThreeYears", title: $gettext("3 Years") },
      ],
    },
  ];
};

export const transformDateFilter = (orgFilter) => {
  const filter = JSON.parse(JSON.stringify(orgFilter));
  if (filter.operator === "eq") {
    filter.operator = "between";
    let fromDate = filter.value + " 00:00:00";
    let toDate = filter.value + " 23:59:59";
    // to UTC time
    console.log(fromDate, toDate);
    fromDate = toUTCDate(fromDate);
    toDate = toUTCDate(toDate);
    filter.value = fromDate + "," + toDate;
  } else if (filter.operator === "gte") {
    filter.value = toUTCDate(filter.value + " 00:00:00");
  } else if (filter.operator === "lte") {
    filter.value = toUTCDate(filter.value + " 23:59:59");
  } else if (filter.operator === "gt") {
    filter.value = toUTCDate(filter.value + " 23:59:59");
  } else if (filter.operator === "lt") {
    filter.value = toUTCDate(filter.value + " 00:00:00");
  } else if (filter.operator === "between") {
    // regex for current date time DD/MM/YYYY
    // todo: im assuming that there are two dates selected
    console.log(filter.value, "between filter.value");
    let [fromDate, toDate] = filter.value.match(
      /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/gm
    );
    fromDate = toUTCDate(fromDate + " 00:00:00");
    toDate = toUTCDate(toDate + " 23:59:59");
    filter.value = fromDate + "," + toDate;
  }
  return filter;
};
export const displayFileSize = (size) => {
  let _size = size;
  let i = 0;
  const fSExt = ["B", "KB", "MB", "GB"];
  //check if file is in GB,MB,KB or Bytes
  while (_size > 1000) {
    _size /= 1024; //divide file size
    i++;
  }
  return Math.round(_size * 100) / 100 + fSExt[i];
};
export const rules = {
  required: (v) => !!v || $gettext("Field is required"),
  requiredArray: (v) =>
    (!!v && v.length !== 0) || $gettext("Field is required"),
  email: (v) => !v || /.+@.+\..+/.test(v) || $gettext("Invalid email"),
  maxLength: (maxLength, v) => {
    console.log(maxLength, "maxLength");
    console.log(v, "v");
    return (
      (!!v && v.length <= maxLength) ||
      $gettext("Maximum character allowed is") + " " + maxLength
    );
  },
  requiredProperty: (property, object) => {
    console.log(property, object);
    console.log(!!(object && object[property]));
    return !!(object && object[property]) || $gettext("Field is required");
  },
};
export default {
  serialize(obj) {
    if (!obj) return "";
    const str = [];
    for (const p in obj) {
      if (Array.isArray(obj[p])) {
        obj[p].forEach((e) => {
          str.push(encodeURIComponent(p) + "[]=" + encodeURIComponent(e));
        });
      } else {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    }
    return str.join("&");
  },

  caseStripRelation(text) {
    const relationMap = {};
    // convert camelCase and snake_case to normal case
    const caseStrippedRelation = text
      .replace(/[A-Z]/g, (m) => "_" + m.toLowerCase())
      .split("_")
      .join(" ")
      .toLowerCase()
      .trim();
    if (typeof relationMap[caseStrippedRelation] !== "undefined") {
      if (relationMap[caseStrippedRelation] === "") return "";
      return relationMap[caseStrippedRelation];
    } else {
      return caseStrippedRelation.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  },

  async autoLoad(state) {
    const yearSelected = useAppStore().yearSelected;
    const result = await state.loader.call(
      null,
      "limit=-1&year=" + yearSelected
    );
    if (result.error) {
      state.touched = false;
    } else {
      state.touched = "loaded";
      state.list = result.list || result;
    }
    return state.list;
  },

  alias(s) {
    return s
      .toString()
      .normalize("NFD")
      .replace(/'/g, "-")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/&/g, "")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  },

  capitalize(string) {
    return string.replace(/\b\w/g, (l) => l.toUpperCase());
  },

  formData(data) {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      // remove private property
      if (key.startsWith("__")) return;
      if (Array.isArray(data[key])) {
        if (data[key].length > 0) {
          data[key].forEach((value) => {
            formData.append(`${key}[]`, value.id || value);
          });
        } else {
          // todo: check how to submit empty array
          formData.append(key, "isEmpty");
        }
      } else if (typeof data[key] === "object" && data[key] !== null) {
        if (data[key] instanceof File) {
          formData.append(key, data[key]);
        }
        data[key] = toRaw(data[key]);
        // console.log(data[key], key)
        if (data[key].id) {
          formData.append(key, data[key].id);
        } else {
          Object.keys(data[key]).forEach((prop) => {
            if (
              data[key][prop] === null ||
              data[key][prop] === undefined ||
              data[key][prop] === "undefined"
            ) {
              return;
            }
            formData.append(`${key}[${prop}]`, data[key][prop]);
          });
        }
      } else {
        if (data[key] === null) {
          // skip
        } else {
          formData.append(key, data[key]);
        }
      }
    });
    return formData;
  },
  generateJWT(username, passwordEncrypted) {
    var sha256 = function sha256(ascii) {
      function rightRotate(value, amount) {
        return (value >>> amount) | (value << (32 - amount));
      }

      var mathPow = Math.pow;
      var maxWord = mathPow(2, 32);
      var lengthProperty = "length";
      var i, j; // Used as a counter across the whole file
      var result = "";

      var words = [];
      var asciiBitLength = ascii[lengthProperty] * 8;

      //* caching results is optional - remove/add slash from front of this line to toggle
      // Initial hash value: first 32 bits of the fractional parts of the square roots of the first 8 primes
      // (we actually calculate the first 64, but extra values are just ignored)
      var hash = (sha256.h = sha256.h || []);
      // Round constants: first 32 bits of the fractional parts of the cube roots of the first 64 primes
      var k = (sha256.k = sha256.k || []);
      var primeCounter = k[lengthProperty];
      /*/
      var hash = [], k = [];
      var primeCounter = 0;
      //*/

      var isComposite = {};
      for (var candidate = 2; primeCounter < 64; candidate++) {
        if (!isComposite[candidate]) {
          for (i = 0; i < 313; i += candidate) {
            isComposite[i] = candidate;
          }
          hash[primeCounter] = (mathPow(candidate, 0.5) * maxWord) | 0;
          k[primeCounter++] = (mathPow(candidate, 1 / 3) * maxWord) | 0;
        }
      }

      ascii += "\x80"; // Append Ƈ' bit (plus zero padding)
      while ((ascii[lengthProperty] % 64) - 56) ascii += "\x00"; // More zero padding
      for (i = 0; i < ascii[lengthProperty]; i++) {
        j = ascii.charCodeAt(i);
        if (j >> 8) return; // ASCII check: only accept characters in range 0-255
        words[i >> 2] |= j << (((3 - i) % 4) * 8);
      }
      words[words[lengthProperty]] = (asciiBitLength / maxWord) | 0;
      words[words[lengthProperty]] = asciiBitLength;

      // process each chunk
      for (j = 0; j < words[lengthProperty]; ) {
        var w = words.slice(j, (j += 16)); // The message is expanded into 64 words as part of the iteration
        var oldHash = hash;
        // This is now the undefinedworking hash", often labelled as variables a...g
        // (we have to truncate as well, otherwise extra entries at the end accumulate
        hash = hash.slice(0, 8);

        for (i = 0; i < 64; i++) {
          var i2 = i + j;
          // Expand the message into 64 words
          // Used below if
          var w15 = w[i - 15],
            w2 = w[i - 2];

          // Iterate
          var a = hash[0],
            e = hash[4];
          var temp1 =
            hash[7] +
            (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) + // S1
            ((e & hash[5]) ^ (~e & hash[6])) + // ch
            k[i] +
            // Expand the message schedule if needed
            (w[i] =
              i < 16
                ? w[i]
                : (w[i - 16] +
                    (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3)) + // s0
                    w[i - 7] +
                    (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10))) | // s1
                  0);
          // This is only used once, so *could* be moved below, but it only saves 4 bytes and makes things unreadble
          var temp2 =
            (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) + // S0
            ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2])); // maj

          hash = [(temp1 + temp2) | 0].concat(hash); // We don't bother trimming off the extra ones, they're harmless as long as we're truncating when we do the slice()
          hash[4] = (hash[4] + temp1) | 0;
        }

        for (i = 0; i < 8; i++) {
          hash[i] = (hash[i] + oldHash[i]) | 0;
        }
      }

      for (i = 0; i < 8; i++) {
        for (j = 3; j + 1; j--) {
          var b = (hash[i] >> (j * 8)) & 255;
          result += (b < 16 ? 0 : "") + b.toString(16);
        }
      }
      return result;
    };
    let nonce = "";
    const possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < 11; i++) {
      nonce += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    const created = Math.floor(Date.now() / 1000);
    const passwordDigest = sha256(nonce + created + passwordEncrypted);
    return `/UsernameToken Email="${username}", PasswordDigest="${passwordDigest}", Nonce="${nonce}", Created="${created}"/`;
  },
};

export const YearPlaceholder = () => {
  return {
    current_year: import.meta.env.VITE_CURRENT_YEAR,
    next_year: import.meta.env.VITE_CURRENT_YEAR + 1,
    last_year: import.meta.env.VITE_CURRENT_YEAR - 1,
    last_2_year: import.meta.env.VITE_CURRENT_YEAR - 2,
    last_3_year: import.meta.env.VITE_CURRENT_YEAR - 3,
    last_4_year: import.meta.env.VITE_CURRENT_YEAR - 4,
    last_5_year: import.meta.env.VITE_CURRENT_YEAR - 5,
  };
};
export const validateCondition = (conditionString) => {
  const surveyStore = useSurveyStore();
  const regex = /([a-zA-Z0-9]+)([=!<>⊃]+)(['a-zA-Z0-9._]+)/g;
  let match;
  let result = true;
  while ((match = regex.exec(conditionString)) !== null) {
    let [_, leftValue, operator, rightValue] = match;
    //console.log(leftValue, operator, rightValue, 'start regex')
    if (leftValue.startsWith("q")) {
      const questionId = leftValue.slice(1);
      leftValue = surveyStore.getAnswer(questionId);
    }
    if (rightValue === "'empty'") {
      if (operator === "=") {
        if (
          leftValue !== null &&
          leftValue !== undefined &&
          leftValue !== "" &&
          (!Array.isArray(leftValue) || leftValue.length !== 0)
        ) {
          result = false;
        }
        break;
      } else if (operator === "!=") {
        if (
          leftValue === null ||
          leftValue === undefined ||
          leftValue === false ||
          leftValue === "" ||
          (Array.isArray(leftValue) && leftValue.length == 0)
        ) {
          result = false;
        }
        break;
      }
    }
    if (rightValue.includes(".")) {
      rightValue = rightValue
        .split(".")
        .reduce((obj, prop) => obj?.[prop], surveyStore.getSurvey);
    }
    const surveyProps = Object.keys(surveyStore.getSurvey ?? {});
    if (surveyProps.length > 0 && surveyProps.includes(rightValue)) {
      rightValue = surveyStore.getSurvey[rightValue];
    }
    if (!isNaN(rightValue)) {
      rightValue = Number(rightValue);
    }
    if (leftValue === undefined) {
      result = false;
      break;
    }
    //console.log(leftValue, operator, rightValue, conditionString)
    switch (operator) {
      case "⊃":
        if (!leftValue.includes(rightValue)) result = false;
        break;
      case "=":
        if (Array.isArray(rightValue)) {
          if (!leftValue.includes(rightValue)) result = false;
        } else {
          if (leftValue != rightValue) result = false;
        }
        break;
      case "!=":
        if (leftValue == rightValue) result = false;
        break;
      case ">":
        if (!(leftValue > rightValue)) result = false;
        break;
      case "<":
        if (!(leftValue < rightValue)) result = false;
        break;
      default:
        result = false;
        break;
    }
    if (!result) break;
  }
  return result;
};
export const isDev = () => {
  return process.env.NODE_ENV !== "production";
};
